import * as React from 'react';

import {
  DropdownMenu,
  DropdownMenuCheckboxItem,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuPortal,
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
  DropdownMenuSeparator,
  DropdownMenuShortcut,
  DropdownMenuSub,
  DropdownMenuSubContent,
  DropdownMenuSubTrigger,
  DropdownMenuTrigger,
} from './components/ui/dropdown-menu.js';
import { cn } from './lib/utils.js';

export function DimeDropdownMenu({
  ...props
}: Readonly<React.ComponentProps<typeof DropdownMenu>>) {
  return <DropdownMenu {...props} />;
}

export function DimeDropdownMenuPortal({
  ...props
}: Readonly<React.ComponentProps<typeof DropdownMenuPortal>>) {
  return <DropdownMenuPortal {...props} />;
}

export function DimeDropdownMenuTrigger({
  ...props
}: Readonly<React.ComponentProps<typeof DropdownMenuTrigger>>) {
  return <DropdownMenuTrigger {...props} />;
}

export function DimeDropdownMenuContent({
  ...props
}: Readonly<React.ComponentProps<typeof DropdownMenuContent>>) {
  return <DropdownMenuContent {...props} />;
}

export function DimeDropdownMenuGroup({
  ...props
}: Readonly<React.ComponentProps<typeof DropdownMenuGroup>>) {
  return <DropdownMenuGroup {...props} />;
}

export function DimeDropdownMenuItem({
  ...props
}: Readonly<React.ComponentProps<typeof DropdownMenuItem>>) {
  return <DropdownMenuItem {...props} />;
}

export function DimeDropdownMenuCheckboxItem({
  ...props
}: Readonly<React.ComponentProps<typeof DropdownMenuCheckboxItem>>) {
  return <DropdownMenuCheckboxItem {...props} />;
}

export function DimeDropdownMenuRadioGroup({
  ...props
}: Readonly<React.ComponentProps<typeof DropdownMenuRadioGroup>>) {
  return <DropdownMenuRadioGroup {...props} />;
}

export function DimeDropdownMenuRadioItem({
  ...props
}: Readonly<React.ComponentProps<typeof DropdownMenuRadioItem>>) {
  return <DropdownMenuRadioItem {...props} />;
}

export function DimeDropdownMenuLabel({
  ...props
}: Readonly<React.ComponentProps<typeof DropdownMenuLabel>>) {
  return <DropdownMenuLabel {...props} />;
}

export function DimeDropdownMenuSeparator({
  ...props
}: Readonly<React.ComponentProps<typeof DropdownMenuSeparator>>) {
  return <DropdownMenuSeparator {...props} />;
}

export function DimeDropdownMenuShortcut({
  ...props
}: Readonly<React.ComponentProps<typeof DropdownMenuShortcut>>) {
  return <DropdownMenuShortcut {...props} />;
}

export function DimeDropdownMenuSub({
  ...props
}: Readonly<React.ComponentProps<typeof DropdownMenuSub>>) {
  return <DropdownMenuSub {...props} />;
}

export function DimeDropdownMenuSubTrigger({
  ...props
}: Readonly<React.ComponentProps<typeof DropdownMenuSubTrigger>>) {
  return <DropdownMenuSubTrigger {...props} />;
}

export function DimeDropdownMenuSubContent({
  className,
  ...props
}: Readonly<React.ComponentProps<typeof DropdownMenuSubContent>>) {
  return (
    <DropdownMenuSubContent
      className={cn(
        'max-h-(--radix-dropdown-menu-content-available-height) overflow-x-hidden overflow-y-auto',
        className,
      )}
      {...props}
    />
  );
}
